import { SuppliesSubscriptionOrderInterval } from "@redotech/cockroachdb-codegen/tables/product/supplies-subscription-order-interval";
import { SuppliesSubscriptionStatus } from "@redotech/cockroachdb-codegen/tables/product/supplies-subscription-status";
import { suppliesSubscriptionIdFormat } from "@redotech/redo-marketplace-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

// Cadence is edited as a unit so the interval and its anchor stay coherent.
const CadenceUpdateSchema = z.object({
  orderInterval: z.enum(SuppliesSubscriptionOrderInterval),
  orderIntervalFrequency: z.number().int().positive(),
  orderDayOfWeek: z.number().int().min(0).max(6).nullable(),
  orderDayOfMonth: z.number().int().min(1).max(31).nullable(),
});

export const updateSuppliesSubscription = {
  name: "updateSuppliesSubscription" as const,
  input: z.object({
    subscriptionId: suppliesSubscriptionIdFormat.schema,
    quantity: z.number().int().positive().optional(),
    status: z.enum(SuppliesSubscriptionStatus).optional(),
    cadence: CadenceUpdateSchema.optional(),
    // Re-phases the schedule onto this date (also moves the anchor to match).
    nextReorderDate: zExt.plainDate().optional(),
  }),
  output: z.object({}),
};
